import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { ActiveLink } from './';

class NetworkLink extends Component {
	render() {

		const { logout, link, src, notifications, buttonBadge, logoutFunction } = this.props;
		if( !logout ) {
			return (
                <ActiveLink to={ link }>
					{
						src &&
                        <img className={ `itn-menu-item${ !buttonBadge ? ' no-button-badge' : '' }` }
                             src={ src }
                             alt="Network Link" />
					}
					{
						buttonBadge && <span className={ `${ buttonBadge ? 'button-badge' :  '' }` }>{ notifications }</span>
					}
                </ActiveLink>
			);
		}

		return (
	      <button className="btn btn-login" onClick={ logoutFunction }>
		      <img src={ src } alt="" />
		      <span className="login-label">Logout</span>
	      </button>
		);

	}
}

NetworkLink.propTypes = {
	logout: PropTypes.bool.isRequired,
	link: PropTypes.string,
	src: PropTypes.string.isRequired,
	notifications: PropTypes.oneOfType( [ PropTypes.bool, PropTypes.number ] ),
	buttonBadge: PropTypes.bool.isRequired,
	logoutFunction: PropTypes.func,
};

export default NetworkLink;



// WEBPACK FOOTER //
// src/client/components/common/link/NetworkLink.js